module.exports = __webpack_public_path__ + "static/media/espirelogo-black.5cf4b855.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/espirelogo-black.png
// module id = 615
// module chunks = 0